<template>
  <div class="container-fluid mt-5">
    <div class="card" style="width: 100%; margin: 1 auto;">
      <div class="card-body">
        <h1>Documentar Equipaje</h1>
        <br>
        <div class="input-group mb-3">
          <input type="text" class="form-control search-size" placeholder="Buscar boleto" v-model="searchTicket"
            @keyup.enter="search">
          <div class="input-group-append">
            <button class="btn btn-default ml-auto" type="button" @click="search">Buscar</button>
          </div>
        </div>
        <template v-if="ticket">
          <h1>Información de Boleto #{{ ticket.id }}</h1>
          <br>
          <h4>Corrida: #{{ ticket.corrida_id }}</h4>
          <h4>Sub-Corrida: #{{ ticket.subcorrida_id }}</h4>
          <h4>Fecha/Hora de salida: {{ ticket.fecha_salida }}</h4>
          <br>
          <h4>Terminal Origen: {{ ticket.terminal_origen }}</h4>
          <h4>Subida: {{ ticket.paradero_origen }}</h4>
          <h4>Terminal Destino: {{ ticket.terminal_destino }}</h4>
          <h4>Bajada: {{ ticket.paradero_destino }}</h4>
          <br>
          <h4>Pasajero: {{ ticket.nombre_pasajero }}</h4>
          <h4>Asiento: {{ ticket.asiento }}</h4>
          <h4>Edad: {{ ticket.edad }}</h4>
          <br>
          <h4>Número de piezas de equipaje gratis: {{ ticket.num_piezas_equipaje_gratis }}</h4>
          <div class="table-responsive align-items-center table-flush">
            <table class="table header-white">
              <thead>
                <tr>
                  <th v-for="(header, index) in headers" :key="index" class="two-lines">{{ header.text }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="items.length">
                  <tr v-for="item in items" :key="item.id">
                    <td v-for="(header, index) in headers" :key="index">
                      <template v-if="header.value === 'created_at'">{{
                        item[header.value] | moment('DD-MM-YYYY HH:mm')
                      }}</template>
                      <template v-else-if="header.value === 'es_extra'">{{ item[header.value]? 'Si' : 'No' }}</template>
                      <template v-else-if="header.value === 'documentado'">{{
                        item[header.value]? 'Si' : 'No'
                      }}</template>
                      <template v-else-if="header.value === 'btn_doc' && item.es_extra && !item.documentado">
                        <button class="btn btn-primary" @click="showModalAdditional = { show: true, item: item.id }">Documentar</button>
                      </template>
                      <template v-else>{{ item[header.value] }}</template>
                      <template v-if="header.value === 'imprimir'">
                        <base-button type="primary" title="Imprimir ticket de equipaje" icon size="sm" @click="imprimir(item)">
                            <span class="btn-inner--icon"><i class="fas fa-print"></i></span>
                        </base-button>
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="7" class="text-center">Sin datos disponibles</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <br>
          <button class="btn btn-primary" @click="showModalFree = true"
            :disabled="ticket.num_piezas_equipaje_gratis_restantes <= 0">Documentar Equipaje Gratuito</button>
        </template>

        <template v-else-if="error">
          <p>{{ error }}</p>
        </template>
      </div>
    </div>

    <template class="modal" v-if="showModalFree">
      <div tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered fixed-top" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Documentar Equipaje Gratuito</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                @click="closeModalFree">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <input type="text" class="form-control" placeholder="Descripción"
                v-model="documentarFree.descripcion_equipaje" maxlength="180">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" :disabled="btnDisabledFree"
                @click="documentationFree">Documentar</button>
              <button type="button" class="btn btn-secondary" @click="closeModalFree">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template class="modal" v-if="showModalAdditional">
      <div tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered fixed-top" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Documentar Equipaje Extra #{{ showModalAdditional.item }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                @click="closeModalAdditional">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <input type="text" class="form-control" placeholder="Descripción"
                v-model="documentar.descripcion_equipaje" maxlength="180">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" :disabled="btnDisabledAdditional"
                @click="additionalDocumentation">Documentar</button>
              <button type="button" class="btn btn-secondary" @click="closeModalAdditional">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>
<script>
import Vue from 'vue';
import {Impresora} from "@/printer/Impresora.js";
import ImpresionDocumentar from "./ImpresionDocumentar.vue";
export default {
  data() {
    return {
      documentarPrinter: null,
      searchTicket: '',
      ticket: '',
      items: [],
      linea: null,
      headers: [
        { text: 'Fecha Creación', value: 'created_at' },
        { text: '# Pieza Equipaje', value: 'id' },
        { text: 'Es extra', value: 'es_extra' },
        { text: 'Documentado', value: 'documentado' },
        { text: 'Fecha Documentado', value: 'fecha_documentado' },
        { text: 'Descripción', value: 'descripcion_equipaje' },
        { text: 'Opciones', value: 'imprimir' },
        { text: '', value: 'btn_doc' },
      ],
      showModalFree: false,
      showModalAdditional: false,
      error: '',
      btnDisabledFree: true,
      descriptionAdditional: '',
      btnDisabledAdditional: true,
      documentar: {
        type: "equipaje",
        id: null,
        descripcion_equipaje: null
      },
      documentarFree: {
        type: "equipaje",
        boleto_id: null,
        descripcion_equipaje: null
      }
    }
  },
  watch: {
    'documentarFree.descripcion_equipaje': function (val) {
      this.btnDisabledFree = val === ''
    },
    'documentar.descripcion_equipaje': function (val) {
      this.btnDisabledAdditional = val === ''
    }
  },
  methods: {
    async addImageToPrint(linea){
      //transforma imagen a base64
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); 
          reader.onloadend = () => {
            const base64data = reader.result;   
            resolve(base64data);
          }
        });
      }
      let imagen;
      //elige imagen a imprimir según linea de ruta
      switch(linea){
        case 1:
          imagen = await getBase64FromUrl('/img/logoPrinter.png');
          return imagen;
        case 2:
          imagen = await getBase64FromUrl('/img/logoPrinter3.png');
          return imagen;
      }
    },
    async imprimir(item) {
      //se obtienen datos de usuario autenticado
      let me = await this.$store.getters["profile/me"];
      let equipaje = item;
      let imagen = await this.addImageToPrint(this.linea);

      let printer = new Impresora;
      let tablaClass = Vue.extend(ImpresionDocumentar);
      let tablaInstancia = new tablaClass({
        propsData: { 
          boleto: this.ticket,
          equipaje: equipaje,
          user: me.attributes,
        }
      });
      let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
      let tabla = this.changeSimbol(tabla_html);
      const today = new Date();
      const date = ("0" + today.getDate()).slice(-2) + "" + ("0"+(today.getMonth()+1)).slice(-2) + "" + today.getFullYear()  + "/" + ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2)
      printer.setAlign("center");
      printer.imagen(imagen);
      printer.setAlign("left");
      printer.html(tabla);
      printer.setAlign("center");
      printer.qr(equipaje.id, 25);
      printer.html(`<!DOCTYPE html><html><body><p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">`+me.attributes.username+'/'+date+`</p></body></html>`)
      printer.cut();
      printer.setAlign("center");
      printer.imagen(imagen);
      printer.setAlign("left");
      printer.html(tabla);
      printer.setAlign("center");
      printer.qr(equipaje.id, 25);
      printer.html(`<!DOCTYPE html><html><body><p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">`+me.attributes.username+'/'+date+`</p></body></html>`)
      printer.cut();
      printer.end().then(respuesta => {
          console.log(respuesta);
          //console.log("resultado: " + respuesta.mensaje);
      });
      this.documentarPrinter = null;
      this.search();
      this.reload();
    },

    reload(){
      this.$router.go(this.$router.currentRoute)
    },

    changeSimbol(s) {
      //var accent_map = {'á':'&aacute;', 'é':'&eacute;', 'è':'e', 'í':'&iacute;','ó':'&oacute;','ú':'&uacute;','Á':'&Aacute;', 'É':'&Eacute;', 'è':'e', 'Í':'&Iacute;','Ó':'&Oacute;','Ú':'&Uacute;', 'ñ':'&ntilde;;', 'Ñ':'&Ntilde;'};
      var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
      if (!s) { return ''; }
      var ret = '';
      for (var i = 0; i < s.length; i++) {
        ret += accent_map[s.charAt(i)] || s.charAt(i);
      }
      return ret;
    },

    closeModalFree() {
      this.showModalFree = false;
      this.documentarFree.descripcion_equipaje = '';
    },
    closeModalAdditional() {
      this.showModalAdditional = false;
      this.documentar.descripcion_equipaje = '';
    },
    async search() {
      this.ticket = '';
      this.error = '';
      this.items = [];
      await this.$store.dispatch("equipajes/get", this.searchTicket)
        .then(() => {
          this.ticket = this.$store.getters["equipajes/get"];
          this.items = this.ticket.equipajes;
          this.linea = this.ticket.ruta.linea;
        })
        .catch(error => {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: error.response.data.errors[0].detail,
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        })
    },
    async additionalDocumentation() {
      this.documentar.id = this.showModalAdditional.item;
      await this.$store.dispatch("equipajes/add", this.documentar)
        .then(() => {
          this.documentarPrinter = this.$store.getters["equipajes/add"];
          this.documentarPrinter = this.documentarPrinter.result;
          this.imprimir(this.documentarPrinter);
          this.documentar.descripcion_equipaje = '';
          this.showModalAdditional = false;
          this.$notify({
            type: "success",
            message: 'Equipaje documentado correctamente',
            duration: -1
          });
        })
        .catch(error => {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: error.response.data.errors[0].detail,
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        })
    },
    async documentationFree() {
      this.documentarFree.boleto_id = this.ticket.id;
      await this.$store.dispatch("equipajes/addFree", this.documentarFree)
        .then(() => {
          this.documentarPrinter = this.$store.getters["equipajes/addFree"];
          this.documentarPrinter = this.documentarPrinter.result;
          this.imprimir(this.documentarPrinter);
          this.documentarFree.descripcion_equipaje = '';
          this.showModalFree = false;
          this.$notify({
            type: "success",
            message: 'Equipaje documentado correctamente',
            duration: -1
          });
        })
        .catch(error => {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: error.response.data.errors[0].detail,
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        })
    },
  }
}
</script>


<style lang="scss">
.argon-error {
  position: relative;
  bottom: 25px !important;
  color: #fb6340;
}

.table-container {
  //width: 100em;
  overflow-x: auto !important;
  white-space: nowrap !important;
}

.argon-error {
  position: relative;
  bottom: 25px !important;
  color: #fb6340;
}

.search-size {
  width: 400px !important;
  flex: none !important;
}

.header-white thead th {
  background-color: #0068a0;
  color: white;
}

.two-lines {
  white-space: pre-line !important;
}
</style>